module.exports = __webpack_public_path__ + "static/media/CentraNo2-Light.5bca36f5.woff";